import { useState } from "react";
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";

export const StatCard = ({ label, value, icon: I, tint = "bg-blue-50 text-[#0052FF]", testid, sub }) => (
  <div className="card-soft rise flex h-full flex-col p-4 sm:p-5" data-testid={testid}>
    <div className="flex items-start justify-between gap-2">
      <span className="label-xs">{label}</span>
      {I && <span className={`grid h-9 w-9 shrink-0 place-items-center rounded-xl ${tint}`}><I className="h-4 w-4" /></span>}
    </div>
    <div className="mt-auto pt-3">
      <div className="font-display text-2xl font-extrabold leading-tight text-slate-900 sm:text-3xl">{value}</div>
      {sub && <div className="mt-0.5 text-xs text-slate-500">{sub}</div>}
    </div>
  </div>
);

export function ConfirmButton({ title, description, onConfirm, children, testid, confirmLabel = "Confirm", ...btn }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button {...btn} onClick={() => setOpen(true)} data-testid={testid}>{children}</Button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent className="rounded-2xl">
          <AlertDialogHeader>
            <AlertDialogTitle className="font-display">{title}</AlertDialogTitle>
            {description && <AlertDialogDescription>{description}</AlertDialogDescription>}
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid={`${testid}-cancel`}>Back</AlertDialogCancel>
            <AlertDialogAction className="bg-[#0052FF] hover:bg-[#0041CC]" onClick={onConfirm} data-testid={`${testid}-confirm`}>{confirmLabel}</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}

export const StatusBadge = ({ status, cls }) => <span className={`chip border capitalize ${cls}`} data-testid={`status-${status}`}>{String(status || "").replace(/_/g, " ")}</span>;
